export const STEPS = Object.freeze({
  FIRST_SCREEN: 1,
  SECOND_SCREEN: 2
});

export const DEFAULT_DATA_FORM = { email: '', company: {} };
export const REGEX_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const REGEX_BUSINESS_EMAIL =
  /^(?!.*@(gmail\.com|gmail\.co|outlook\.com|outlook\.co|yahoo\.com|yahoo\.co|hotmail\.com|hotmail\.co|aol\.com|aol\.co|live\.com|live\.co|msn\.com|msn\.co|icloud\.com|icloud\.co|yopmail\.com|yopmail\.co|oracle\.com|oracle\.co|microsoft\.com|microsoft\.co|buildots\.co|buildots\.com|getbldo\.co|getbldo\.com|getbldx\.co|getbldx\.com)$).+$/;
